import React, {useState, useEffect} from 'react';

import {Button, Spinner, Modal, SelectionInput} from 'player-components';


import './style.css';
import { PlusIcon } from '@heroicons/react/solid';

const AddToSetlistModal = ({setlists, isOpen, onClose, onSelectNewPlaylist, onConfirm}) => {
    const [selectedSetlist, setSelectedSetlist] = useState(setlists[0]);
    const renderSetlists = () => {
        const setlistItems = setlists.map(setlist => ({
            id: setlist.id,
            name: setlist.title,
            avatar: setlist.imageUrl
        }));
        return <div className={'addToSetlistModal-container'}>
            <p>Please select a setlist to add the song to</p>
        <SelectionInput items={setlists} itemSelected={selectedSetlist} onChange={setSelectedSetlist} />
        
        </div>
    }

    const renderAddToNew = () => {
        return <div className="addToNew">
            <span>or</span>
            <Button onClick={onSelectNewPlaylist}><PlusIcon />Create new playlist</Button>
        </div>
    }

    useEffect(()=>{
        if (setlists?.length && isOpen) setSelectedSetlist(setlists[0]);
    },[isOpen, setlists])

    return <Modal 
        isOpen={isOpen}
        content={<div style={{minHeight: 300}}>
        <p className="mb-4"></p>
        {renderSetlists()}
        {renderAddToNew()}
        </div>}
        closeLabel={'Close'}
        onClose={onClose}
        onConfirm={()=>onConfirm(selectedSetlist)}
        confirmLabel={selectedSetlist ? "Add song to setlist": null}
        confirmable={selectedSetlist}
    />
}

export default AddToSetlistModal;